import { render, staticRenderFns } from "./FooterHomeOne.vue?vue&type=template&id=08c85bf4"
import script from "./FooterHomeOne.vue?vue&type=script&lang=js"
export * from "./FooterHomeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports